import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import { RootState } from "redux/store";
import { postRequest } from "helpers/axios";
import { API_ROUTES } from "helpers/constants/apis";
import { toast } from "react-toastify";
import { setActiveElement } from "../redux/slices/elementsNavigationHelperReducer";

interface UseSigningSubmitProps {
  coordinatesList: RootState["coordinatesList"];
  signatureList: RootState["signatureList"];
  textList: RootState["textList"];
  dateList: RootState["dateList"];
  checkboxList: RootState["checkboxList"];
  emailList: RootState["emailList"];
  pickList: RootState["pickList"];
  savePdf: (state: RootState) => void;
  currentReduxState: RootState;
}

export const useSigningSubmit = ({
  coordinatesList,
  signatureList,
  textList,
  dateList,
  checkboxList,
  emailList,
  pickList,
  savePdf,
  currentReduxState,
}: UseSigningSubmitProps) => {
  const dispatch = useDispatch();

  const handleRequiredFieldLogic = (innerElement: any) => {
    try {
      const indicator = document.getElementsByClassName("signature-indicator")[0];
      if (indicator) {
        indicator.innerHTML = `<span><i class="fa-solid fa-circle-arrow-down"></i> Required</span>`;
      }
      const { coordinateId, x, y, screenX, screenY, pageNumber, width, height, isRequired, value } = innerElement;
      dispatch(setActiveElement({ coordinateId, y, x, screenX, screenY, pageNumber, width, height, isRequired, value }));
    } catch (err) {
      // Silently handle DOM errors
    }
  };

  const handleSavePdf = () => {
    const signatureData = signatureList.allSignatureData;
    const textData = textList.allTextData;
    const dateData = dateList.allDateData;
    const checkboxData = checkboxList.allCheckboxData;
    const emailData = emailList.allEmailData;
    const picklistData = pickList.allPicklistData;

    for (const indexNo in signatureData) {
      for (let i = 0; i < signatureData[indexNo].length; i++) {
        const el = signatureData[indexNo][i];
        if (el.isRequired && signatureList.encodedImgData.length === 0) {
          handleRequiredFieldLogic(el);
          return false;
        }
      }
    }
    for (const indexNo in textData) {
      for (let i = 0; i < textData[indexNo].length; i++) {
        const el = textData[indexNo][i];
        if (el.isRequired && el.value.length === 0) {
          handleRequiredFieldLogic(el);
          return false;
        }
      }
    }
    for (const indexNo in dateData) {
      for (let i = 0; i < dateData[indexNo].length; i++) {
        const el = dateData[indexNo][i];
        if (el.isRequired && el.value.length === 0) {
          handleRequiredFieldLogic(el);
          return false;
        }
      }
    }
    for (const indexNo in checkboxData) {
      for (let i = 0; i < checkboxData[indexNo].length; i++) {
        const el = checkboxData[indexNo][i];
        if (el.isRequired && el.value === false) {
          handleRequiredFieldLogic(el);
          return false;
        }
      }
    }
    for (const indexNo in emailData) {
      for (let i = 0; i < emailData[indexNo].length; i++) {
        const el = emailData[indexNo][i];
        if (el.isRequired && !el.value) {
          handleRequiredFieldLogic(el);
          return false;
        }
      }
    }
    for (const indexNo in picklistData) {
      for (let i = 0; i < picklistData[indexNo].length; i++) {
        const el = picklistData[indexNo][i];
        if (el.isRequired && !el.value) {
          handleRequiredFieldLogic(el);
          return false;
        }
      }
    }

    if (coordinatesList.allCoordinateData.length === 0) {
      toast.error("No fields are present on this document.");
      return false;
    }

    savePdf(currentReduxState);
    return true;
  };

  return { handleSavePdf, handleRequiredFieldLogic };
};
